import React, {
  useEffect, useState, useReducer,
} from 'react';


const bookedContext = React.createContext ();

const useBooked = () => {
  const [ initialized, setInitialized ] = useState(false);
  const [ appointment, setAppointment]  = useState (null)

  const book = (apt) => {
    localStorage.apt = JSON.stringify(apt);
    setAppointment(apt);
  }

  const dismiss = () => {
    delete localStorage.apt;
    setAppointment(null)
  }

  const cancel = () => {
    try {
      const apt = JSON.parse(localStorage.apt);
      apt.cancelled = true;
      localStorage.apt = JSON.stringify(apt);
      setAppointment(apt);
    } catch (e) {

    }
  }
  useEffect (() => {
    if (!initialized)
    (async() => {
      if (localStorage.apt) {
        try {
          const apt = JSON.parse(localStorage.apt);
          setInitialized(true);
          if (apt.from > +new Date) {
            setAppointment(apt);
          } else {
            delete localStorage.apt
          }
        } catch (e) {
          
        }
      }
    })()
  }) 

  return {
    isPending: !initialized,
    appointment,
    book,
    cancel,
    dismiss
  }
}

const BookedProvider = ({children}) => {
  const { isPending, appointment, book, dismiss, cancel } = useBooked ();
  return <bookedContext.Provider value={{ isPending, appointment, book, dismiss, cancel }}>
    {children}
  </bookedContext.Provider>
}

export { BookedProvider, bookedContext }